export default {
  sentiment: 'Sentiment',
  medias: 'Medias',
  news: 'News Portals',
  quotes: 'Quotes',
  valoration: 'Advertising Value',
  centage: 'Measurement',
  minute: 'Timing',
};
